import { getColor } from '../../../../theme-tools';
import { asSingleStyleConfig } from '../../../../utils/theme';
export var variantPrimary = props => {
  var {
    theme
  } = props;
  return {
    button: {
      _after: {
        left: 2,
        right: 2,
        bottom: 0,
        height: '4px',
        borderRadius: '1px'
      },
      _focus: {
        '&:after': {
          height: 0
        }
      },
      _active: {
        '&:after': {
          background: getColor(theme, 'green.500')
        }
      }
    }
  };
};
export var UnderlineButton = asSingleStyleConfig({
  variants: {
    primary: variantPrimary
  }
});